import { Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { theme } from '../../../../../../../../modules/App/Providers/Theme/theme'

const Container = styled('div')`
  align-content: start;
  display: grid;
  margin: 0;
  padding: 0;
  row-gap: 1rem;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    height: 17rem;
    overflow-y: auto;
  }
`

const TimeSlotsSkeleton = () => {
  return (
    <Container>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={36}
          sx={{
            borderRadius: '4px',
          }}
        />
      ))}
    </Container>
  )
}

export { TimeSlotsSkeleton }
